export default __webpack_public_path__ + "static/media/Wawanesa_Insurance_blue.24303ecd.svg";